import { render, staticRenderFns } from "./TopListComponent.vue?vue&type=template&id=3f21e901&scoped=true&"
import script from "./TopListComponent.vue?vue&type=script&lang=js&"
export * from "./TopListComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopListComponent.vue?vue&type=style&index=0&id=3f21e901&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f21e901",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
